import { cx } from '@lastbrand/web-ui-styled-system/css'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface MainPriceColumnProps {
  formattedSalePrice: string
  formattedTraditionalPrice?: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  showNewPdpDesignV2?: boolean
  isB2BFinalSaleProduct?: boolean
  updatedDesignForV2?: boolean
  pdpPriceRedesign?: boolean
  hasPerUnitPricing: boolean
  unitForPerServing: string
  pricePerServing?: number
  traditionalPricePerServing?: number
  earnCreditTagFor3PVendor?: string
}

function MainPriceColumn({
  formattedSalePrice,
  formattedTraditionalPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  showNewPdpDesignV2,
  isB2BFinalSaleProduct,
  updatedDesignForV2,
  pdpPriceRedesign,
  hasPerUnitPricing,
  unitForPerServing,
  pricePerServing,
  traditionalPricePerServing,
  earnCreditTagFor3PVendor,
}: MainPriceColumnProps) {
  const isOfferRow = !!formattedFestivalOfferPrice || isSubscriptionOffer

  return (
    <div
      className={cx(
        styles.priceWrapperMainValueCss,
        isOfferRow ? styles.priceWrapperMainValueQpOfferCss : styles.priceWrapperMainValueQpCss,
        isOfferRow && styles.priceWrapperMainValueQpOfferOriginalCss,
        showNewPdpDesignV2 && styles.priceWrapperMainValueQpNewDesignV2Css,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        (formattedFestivalOfferPrice || isSubscriptionOffer) &&
          showNewPdpDesignV2 &&
          styles.priceWrapperMainValueQpNewDesignV2FestivalPriceCss,
        isB2BFinalSaleProduct && !formattedTraditionalPrice && styles.b2bPriceWrapperCss,
        updatedDesignForV2 && styles.priceWrapperMainValueQpUpdatedDesignV2Css,
      )}
    >
      <span className="sales_price_selector_for_force_update">
        <FormattedPrice amount={formattedSalePrice} />
      </span>
      {hasPerUnitPricing && !formattedFestivalOfferPrice && !isSubscriptionOffer && unitForPerServing && (
        <span
          className={cx(
            styles.priceWrapperMainValuePerservingCss,
            showNewPdpDesignV2 && styles.priceWrapperMainValuePerservingNewDesignV2Css,
          )}
        >
          {'('}
          <span
            className={cx(
              styles.priceWrapperMainValuePerservingTraditionalCss,
              showNewPdpDesignV2 && styles.priceWrapperMainValuePerservingTraditionalNewPdpDesignV2Css,
            )}
          >
            <FormattedPrice amount={traditionalPricePerServing} />{' '}
          </span>
          <FormattedPrice amount={pricePerServing} />/{unitForPerServing}
          {')'}
        </span>
      )}
      {earnCreditTagFor3PVendor && !formattedFestivalOfferPrice && (
        <div
          className={cx(
            styles.priceWrapperMainEarnCreditTagCss,
            pdpPriceRedesign && styles.priceWrapperMainEarnCreditTagRegularWeightCss,
          )}
        >
          {earnCreditTagFor3PVendor}
        </div>
      )}
    </div>
  )
}

export default MainPriceColumn
